// assets
import AccountBookOutlined from '@ant-design/icons/AccountBookOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import LoginOutlined from '@ant-design/icons/LoginOutlined';
import PhoneOutlined from '@ant-design/icons/PhoneOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import RocketOutlined from '@ant-design/icons/RocketOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined';
import { BusinessCenterOutlined, ChecklistRtlRounded, ContactSupportOutlined, SellOutlined, WavesOutlined, Work, WorkOutline } from '@mui/icons-material';
// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  AccountBookOutlined,
  DollarOutlined,
  LoginOutlined,
  PhoneOutlined,
  RocketOutlined,
  HistoryOutlined,
  QuestionCircleOutlined,
  ContactSupportOutlined,
  CalendarOutlined,
  FilePdfOutlined,
  WavesOutlined,
  WorkOutline,
  ChecklistRtlRounded,
  BusinessCenterOutlined
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const finance: NavItemType = {
  id: 'finance-pages',
  title: 'Finance',
  type: 'group',
  divider: true,
  children: [
    {
      id: 'budgets',
      title: 'Budgets',
      type: 'item',
      url: '/finance/budgets',
      icon: icons.AccountBookOutlined,
      target: false,
      permission: 'canViewBudget'
    },
    {
      id: 'funds',
      title: 'Funds',
      type: 'item',
      url: '/finance/funds',
      icon: icons.BusinessCenterOutlined,
      target: false,
      permission: 'canViewBudget'
    },
     {
      id: 'transactions',
      title: 'Transactions',
      type: 'item',
      url: '/finance/transactions',
      icon: icons.BusinessCenterOutlined,
      target: false,
      permission: 'canViewBudget'
    },
    {
      id: 'reconciliation',
      title: 'Reconciliation',
      type: 'item',
      url: '/finance/reconciliation',
      icon: icons.HistoryOutlined,
      target: false,
      permission: 'canViewBudget'
    },
    {
      id: 'delinquency',
      title: 'Delinquency',
      type: 'item',
      url: '/finance/delinquency',
      icon: icons.HistoryOutlined,
      target: false,
      permission: 'canViewAssessments'
    },
    {
      id: 'vendors',
      title: 'Vendors',
      type: 'item',
      url: '/finance/vendors',
      icon: icons.BusinessCenterOutlined,
      target: false,
      permission: 'canViewVendors'
    },
    {
      id: 'finance-work-orders',
      title: 'Work Orders',
      type: 'item',
      url: '/finance/work-orders',
      icon: icons.ChecklistRtlRounded,
      target: false,
      permission: 'canViewWorkOrders'
    },
    {
      id: 'general-ledger',
      title: 'General Ledger',
      type: 'collapse',
      icon: icons.AccountBookOutlined,
      permission: 'canViewGL',
      children: [
        {
          id: 'gl-accounts',
          title: 'Chart of Accounts',
          type: 'item',
          url: '/finance/gl/accounts',
          icon: icons.AccountBookOutlined,
          target: false,
          permission: 'canViewGL'
        },
        {
          id: 'gl-periods',
          title: 'Periods',
          type: 'item',
          url: '/finance/gl/periods',
          icon: icons.CalendarOutlined,
          target: false,
          permission: 'canCloseGLPeriod'
        },
        {
          id: 'gl-posting-queue',
          title: 'Posting Queue',
          type: 'item',
          url: '/finance/gl/posting-queue',
          icon: icons.HistoryOutlined,
          target: false,
          permission: 'canPostGL'
        },
        {
          id: 'gl-reports',
          title: 'Reports',
          type: 'item',
          url: '/finance/gl/reports',
          icon: icons.FilePdfOutlined,
          target: false,
          permission: 'canViewGL'
        }
      ]
    }
  ]
};

export default finance;
